module.exports = __webpack_public_path__ + "img/raw.cacb64ee.svg";